import SimcardProfile from './simcard-profile'
import EsimProfile from './simcard-profile-esim'
import SimServer from "./sim-server"
import MnoApi from "./mno-api"
import Airalo from "./airalo";
import SimcardOperatorApn from "./simcard-operator-apn"
import SimcardProfileAction from "./simcard-profile-action";
import SimTask from "./sim-task";
import SimcardProfileTraffic from "./simcard-profile-traffic";

export default {
  ...SimcardProfile,
  ...EsimProfile,
  ...SimServer,
  ...MnoApi,
  ...Airalo,
  ...SimcardOperatorApn,
  ...SimcardProfileAction,
  ...SimTask,
  ...SimcardProfileTraffic
}
